import { Outlet } from "react-router-dom";

const TipoServicio = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default TipoServicio;
